'use client';

import React from 'react';
import { ClientProviders as CommonClientProviders, AuthenticatedRoute, SelectionProvider } from '@order-up/client/vite';
import { MenuLoadingFallback } from './menu-loading-fallback';

export function ClientProviders({ children }: { children: React.ReactNode }) {
    return (
        <CommonClientProviders
            defaultTheme="system"
            themeStorageKey="bite-menu-theme"
            loadingComponent={<MenuLoadingFallback />}
        >
            <SelectionProvider namespace="menu-app">
                <AuthenticatedRoute
                    requireSelection={{ tenant: true, restaurant: true }}
                    loadingComponent={MenuLoadingFallback}
                >
                    {children}
                </AuthenticatedRoute>
            </SelectionProvider>
        </CommonClientProviders>
    );
}
